/* Metal ratchet (ghirari) for the fragrance carousel.
 *
 * Louder and sharper than a plain tick: every detent is a hard transient plus
 * four inharmonic metal modes, driven through a waveshaper so it bites the way
 * a real steel pawl does. Still synthesised live, so nothing is downloaded.
 */
window.FcTick = (function () {
  var ac = null;
  var bus = null;
  var imp = null;
  var curve = null;

  /* partials of a struck steel bar, deliberately not musical intervals */
  var MODES = [
    { ratio: 1.00, q: 30, gain: 1.00, decay: 0.070 },
    { ratio: 2.74, q: 38, gain: 0.72, decay: 0.050 },
    { ratio: 5.12, q: 46, gain: 0.46, decay: 0.034 },
    { ratio: 8.30, q: 54, gain: 0.24, decay: 0.022 }
  ];

  /* mild saturation: adds the hard edge that makes it read as metal, not wood */
  function shaper(a) {
    if (curve) return curve;
    var n = 1024;
    curve = new Float32Array(n);
    var k = 14;
    for (var i = 0; i < n; i++) {
      var x = (i * 2) / n - 1;
      curve[i] = ((1 + k) * x) / (1 + k * Math.abs(x));
    }
    return curve;
  }

  function ctx() {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!ac) {
      ac = new AC();

      var drive = ac.createWaveShaper();
      drive.curve = shaper(ac);
      drive.oversample = '4x';

      var hp = ac.createBiquadFilter();
      hp.type = 'highpass';
      hp.frequency.value = 900;

      var presence = ac.createBiquadFilter();
      presence.type = 'peaking';
      presence.frequency.value = 3600;
      presence.Q.value = 1.1;
      presence.gain.value = 6;

      var air = ac.createBiquadFilter();
      air.type = 'highshelf';
      air.frequency.value = 7000;
      air.gain.value = 5;

      var comp = ac.createDynamicsCompressor();
      comp.threshold.value = -14;
      comp.knee.value = 3;
      comp.ratio.value = 4;
      comp.attack.value = 0.0005;
      comp.release.value = 0.05;

      var out = ac.createGain();
      out.gain.value = 2.1;

      drive.connect(hp);
      hp.connect(presence);
      presence.connect(air);
      air.connect(comp);
      comp.connect(out);
      out.connect(ac.destination);
      bus = drive;
    }
    if (ac.state === 'suspended') ac.resume();
    return ac;
  }

  /* 1.5ms exciter: a hard strike, not a hiss */
  function impulse(a) {
    if (imp) return imp;
    var len = Math.max(8, Math.floor(a.sampleRate * 0.0015));
    imp = a.createBuffer(1, len, a.sampleRate);
    var d = imp.getChannelData(0);
    for (var i = 0; i < len; i++) {
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 1.4);
    }
    return imp;
  }

  function detent(a, t, amp, base) {
    var src = a.createBufferSource();
    src.buffer = impulse(a);

    var pre = a.createGain();
    pre.gain.value = amp * 1.7;
    src.connect(pre);

    /* the raw transient, straight through: this is the crack */
    var snap = a.createBiquadFilter();
    snap.type = 'highpass';
    snap.frequency.value = 2600;
    var sg = a.createGain();
    sg.gain.setValueAtTime(amp * 0.85, t);
    sg.gain.exponentialRampToValueAtTime(0.0001, t + 0.008);
    pre.connect(snap);
    snap.connect(sg);
    sg.connect(bus);

    /* the ringing body */
    MODES.forEach(function (m) {
      var f = base * m.ratio;
      if (f > 17500) return;
      var bp = a.createBiquadFilter();
      bp.type = 'bandpass';
      bp.frequency.setValueAtTime(f, t);
      bp.Q.value = m.q;
      var env = a.createGain();
      env.gain.setValueAtTime(m.gain, t);
      env.gain.exponentialRampToValueAtTime(0.0001, t + m.decay);
      pre.connect(bp);
      bp.connect(env);
      env.connect(bus);
    });

    src.start(t);
    src.stop(t + 0.01);
  }

  return function play(vol, dir) {
    var a = ctx();
    if (!a) return;

    var t0 = a.currentTime + 0.001;
    var v = Math.max(0, Math.min(1, vol == null ? 0.4 : vol));
    if (v <= 0) return;

    var base = (dir >= 0 ? 2560 : 2380);
    var teeth = 3 + (Math.random() < 0.5 ? 1 : 0);

    for (var i = 0; i < teeth; i++) {
      var t = t0 + i * (0.018 + i * 0.004);
      var amp = v * (1 - i * 0.2);
      var f = base * (1 - i * 0.04);
      if (amp > 0.02) detent(a, t, amp, f);
    }
  };
})();
